/** @package */
export const PYTHON_STARTER_CODE = `
"""
Supported packages:

allotropy
benchling-sdk
numpy
openpyxl
pandas
pyarrow
pydantic
scikit-learn
scipy
statsmodels
"""
from benchling_sdk.benchling import Benchling
from io import BytesIO
import pandas as pd
from typing import NamedTuple

class IOData(NamedTuple):
    name: str
    data: BytesIO | pd.DataFrame

def custom_code(inputs: list[IOData], benchling: Benchling | None = None) -> list[IOData]:
    raise NotImplementedError("TODO: Return list of IOData")
`;
